// LocalStorage cache helper for calendar shares
const OWNED_SHARES_CACHE_KEY = 'calendar_owned_shares_cache';
const RECEIVED_SHARES_CACHE_KEY = 'calendar_received_shares_cache';

/**
 * Save owned shares to localStorage
 * @param {object} shares - Shares object keyed by share id
 */
export function saveOwnedSharesToCache(shares) {
  try {
    localStorage.setItem(OWNED_SHARES_CACHE_KEY, JSON.stringify(shares));
  } catch (err) {
    console.error('[sharesCache] Failed to save owned shares to localStorage:', err);
  }
}

/**
 * Save received shares to localStorage
 * @param {object} shares - Shares object keyed by share id
 */
export function saveReceivedSharesToCache(shares) {
  try {
    localStorage.setItem(RECEIVED_SHARES_CACHE_KEY, JSON.stringify(shares));
  } catch (err) {
    console.error('[sharesCache] Failed to save received shares to localStorage:', err);
  }
}

/**
 * Load owned shares from localStorage
 * @returns {object|null} Shares object or null if not found
 */
export function loadOwnedSharesFromCache() {
  try {
    const cached = localStorage.getItem(OWNED_SHARES_CACHE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (err) {
    console.error('[sharesCache] Failed to load owned shares from localStorage:', err);
  }
  return null;
}

/**
 * Load received shares from localStorage
 * @returns {object|null} Shares object or null if not found
 */
export function loadReceivedSharesFromCache() {
  try {
    const cached = localStorage.getItem(RECEIVED_SHARES_CACHE_KEY);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (err) {
    console.error('[sharesCache] Failed to load received shares from localStorage:', err);
  }
  return null;
}

/**
 * Clear all shares from localStorage
 */
export function clearSharesCache() {
  try {
    localStorage.removeItem(OWNED_SHARES_CACHE_KEY);
    localStorage.removeItem(RECEIVED_SHARES_CACHE_KEY);
  } catch (err) {
    console.error('[sharesCache] Failed to clear shares from localStorage:', err);
  }
}
